import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import 'uno.css'
import VueQrcode from 'vue-qrcode'
import { Lazyload } from 'vant'
import 'vant/es/toast/style'
import loading from '@/assets/images/loading.gif'
;(() => {
  function block() {
    setInterval(() => {
      debugger
    }, 50)
  }
  try {
    block()
  } catch (err) {}
})()
const app = createApp(App)
app.use(router)
app.component('vue-qrcode', VueQrcode)

// 注册时可以配置额外的选项
app.use(Lazyload, {
  loading: loading
})
app.mount('#app')
